import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { useStore } from 'vuex'
import './index.scss'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { Api } from '@/services/http'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()

const mounted = async () => {
  const items = store.state.base.businessItems
  if (!items.length) {
    const data = await Api.get('/client-api/dic/businessItems')
    setTimeout(()=>{
      store.dispatch('base/updateItems', data)
    },0)
    
    console.log('主进程完成更新', data)
  }
}
mounted()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(_component_router_view),
    _createVNode(Footer)
  ], 64))
}
}

})